export default __webpack_public_path__ + "static/media/DefaultAvatar.43d330bc.webp";